module.exports = __webpack_public_path__ + "static/media/sportello_bancario.1995ac6d.md";